import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { inRange, isEmpty, isNumber } from "lodash";
import BetSlipContext from "../../context/BetSlipContext";
import { useNavigate, useParams } from "react-router-dom";
import useScroll from "../../component/Scroll";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";
import AuthContext from "../../context/AuthContext";
import RenderSlip from "./RenderSlip";
const Toss = ({
  name,
  bookmaker,
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  position,
  typeGame,
  setShowBetDialog,
  setLimit,
  setBetSlipObject,
  user,
  scrollHeight,
  marketId,
  setRightTab,
  BetSlip,
  title,
  totalMatched,
}) => {
  const { t } = useTranslation();
  const parmas = useParams();
  const myRef = useRef(null);
  const { defaultStakeLimit } = useContext(AuthContext);
  const [scrollId, setScrollId] = useScroll(myRef);
  const [localLimit, setLocalLimit] = useState({});
  const { showBetDialog, betSlipObject } = useContext(BetSlipContext);
  const naviagte = useNavigate();
  const handelChange = (odds, type, team, item, index) => {
    if (!isEmpty(user)) {
      setRightTab("betslip");
      setScrollId(index);
      setShowBetDialog(true);
      setLimit(localLimit);
      setBetSlipObject((prev) => ({
        ...prev,
        odds: 98,
        teamName: team,
        betType: type,
        playType: "toss",
        newMarketId: marketId,
        object: {
          ...item,
          ...odds,
          teamName: team,
          eventId: detail?.eventId,
          marketId: marketId,
          newMarketId: marketId,
        },
      }));
    } else {
      naviagte("/login");
    }
  };

  const handelLimt = () => {
    let result = profileData?.matchSetting?.find((res) => {
      return res?.type == marketName;
    });
    if (!isEmpty(result)) {
      let obj = result;
      if (!isEmpty(obj)) {
        return obj;
      }
    } else {
      let obj = profileData?.matchSetting?.find(
        (res) =>
          res?.type == (typeGame == "bookmaker" ? "bookmaker" : "betFaire") &&
          (profileData?.arrayCheck == "details"
            ? true
            : res?.sportType == detail?.gameType)
      );

      if (!isEmpty(obj)) {
        if (marketName == "Match Odds") {
          if (!isEmpty(detail?.betLimitSetting)) {
            return !isEmpty(obj)
              ? {
                  ...obj,
                  minAmount: detail?.betLimitSetting?.minBet,
                  maxAmount: detail?.betLimitSetting?.maxBet,
                }
              : {};
          } else {
            return !isEmpty(obj) ? obj : {};
          }
        } else {
          return obj;
        }
      } else {
        return {
          maxAmount: 500,
          maxProfit: 10000,
          minAmount: 1,
          oddsLimit: 20,
        };
      }
    }
  };

  useEffect(() => {
    let limit = handelLimt();
    if (totalMatched > 0) {
      let newLimit = defaultStakeLimit?.find((res) => {
        return (
          res?.betfairId == detail.eventType &&
          res?.market == name &&
          inRange(totalMatched, res?.min, res?.max)
        );
      });
      if (isEmpty(newLimit)) {
        setLocalLimit(limit);
      } else {
        setLocalLimit({ ...limit, maxAmount: newLimit?.stake });
      }
    } else {
      setLocalLimit(limit);
    }
  }, [marketName, totalMatched, defaultStakeLimit, name]);

  const format = (number) => {
    var nf = new Intl.NumberFormat();
    return nf.format(number);
  };
  return (
    <div data-aos="zoom-in-up" className="leagueBox ">
      <div className="title" style={{ borderRadius: "0" }}>
        <Row>
          <Col style={{ fontWeight: "600" }} md={6}>
            {title}
          </Col>

          <Col md={6} className="text-dark text-center">
            <Row style={{ fontWeight: "600" }}>
              <Col className="text-center text-white" md={6}></Col>
              <Col className="text-center text-white" md={6}>
                {t("Back")}
              </Col>{" "}
            </Row>
          </Col>
        </Row>
      </div>
      {/* <div className="laegueRow position-relative" style={{ padding: "0 8px" }}>
        {runner?.map((item, index) => {
          return (
            <div
              style={
                runner?.length - 1 !== index
                  ? { borderBottom: "1px solid #ddd" }
                  : {}
              }
              className="laegueRow position-relative"
            >
              <Row className="position-relative">
                <Col md={6} className={"text-black selection-slip"}>
                  <span style={{ fontSize: "15px", padding: "10px 0" }}>
                    {item?.RunnerName || item?.runnerName}
                  </span>
                  {(Math?.abs(item?.position) > 0 ||
                    Math.abs(item?.newPosition) > 0) && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "13px",
                        marginLeft: "10px",
                      }}
                      className={` ${
                        item?.position > 0
                          ? "text-green team-red-score"
                          : "team-red-score"
                      }`}
                    >
                      {position?.length > 0 && isNumber(item?.position)
                        ? item?.position > 0
                          ? Math?.abs(item?.position).toFixed(2)
                          : `( ${Math.abs(item?.position).toFixed(2)} )`
                        : ""}
                      {Math.abs(item?.newPosition) >= 0 &&
                        showBetDialog &&
                        betSlipObject?.playType == "toss" && (
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "5px",
                              fontSize: "13px",
                            }}
                            className={
                              item?.newPosition > 0
                                ? "text-green"
                                : "team-red-score"
                            }
                          >
                            <FaArrowRight
                              color={item?.newPosition > 0 ? "green" : "red"}
                              style={{ marginRight: "3px" }}
                            />
                            {item?.newPosition > 0
                              ? Math.abs(item?.newPosition).toFixed(2)
                              : `( ${Math.abs(item?.newPosition).toFixed(2)} )`}
                          </span>
                        )}
                    </span>
                  )}
                </Col>{" "}
                <Col md={3} className="text-dark text-center p-0"></Col>
                <Col md={3} className="text-dark text-center p-0">
                  <div
                    onClick={() => {
                      handelChange(98, "back", item?.RunnerName, item, index);
                    }}
                    className={"position-relative bluBoxs w-100"}
                  >
                    <div style={{ fontWeight: "800", fontSize: "14px" }}>
                      98
                    </div>
                    <span></span>
                  </div>
                </Col>
              </Row>{" "}
              {name == "toss" &&
                betSlipObject?.teamName ==
                  (item?.RunnerName || item?.runnerName) &&
                !isEmpty(betSlipObject?.betType) &&
                betSlipObject?.playType == "toss" && <RenderSlip />}
            </div>
          );
        })}
      </div> */}

      <div class="table-responsive analysis-running-market bookmakerbs">
        <table class="w-100 bets">
          <tbody
            style={{
              borderLeft: "white",
              borderRight: "white",
              position: "relative",
            }}
          >
            <tr class="bet-all-new">
              <td style={{ borderRight: "none" }} class="w-55 mob-minmax"></td>
              <td style={{ borderLeft: "none" }} class="w-45 text-center">
                <div>
                  <div class="w-50 float-left">
                    <>
                      <a
                        id="btnBack"
                        class="bid  btn-back mobile-hide bg-trans lh22"
                        side="Back"
                      ></a>
                      <a
                        id="btnBack"
                        class="bid  btn-back mobile-hide bg-trans lh22"
                        side="Back"
                      ></a>
                    </>

                    <a id="backAll" class="bid  back-all lh22 bid1">
                      <span class="f11">Back</span>
                    </a>
                  </div>
                  <div class="w-50 float-left">
                    <a id="layAll" class="ask  lay-all lh22 ask1">
                      <span class="f11">Lay</span>
                    </a>

                    <>
                      <a
                        id="btnBack"
                        class="ask btn-lay mobile-hide bg-trans lh22"
                        side="lay"
                      ></a>
                      <a
                        id="btnLay"
                        class="ask  btn-lay mobile-hide bg-trans lh22"
                        side="lay"
                      ></a>
                    </>
                  </div>
                </div>
              </td>
            </tr>
            {runner?.map((item, index) => {
              return (
                <>
                  <tr>
                    <td style={{ borderRight: "none" }} class="w-55">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          marginLeft: "5px",
                        }}
                      >
                        <span class="in-play-title">
                          {item?.RunnerName || item?.runnerName}
                        </span>
                        {Math.abs(item?.position) > 0 ||
                        Math.abs(item?.newPosition) ? (
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "11px",
                              marginLeft: "4px",
                            }}
                            className={` ${
                              item?.position > 0
                                ? "text-green team-red-score"
                                : "team-red-score"
                            }`}
                          >
                            {isNumber(item?.position) &&
                            Math.abs(item?.position) > 0
                              ? item?.position > 0
                                ? Math?.abs(item?.position).toFixed(2)
                                : `(${Math.abs(item?.position).toFixed(2)})`
                              : ""}
                            {Math.abs(item?.newPosition) >= 0 &&
                              showBetDialog &&
                              betSlipObject?.playType == "toss" && (
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "4px",
                                    fontSize: "11px",
                                  }}
                                  className={
                                    item?.newPosition > 0
                                      ? "text-green"
                                      : "team-red-score"
                                  }
                                >
                                  <FaArrowRight
                                    color={
                                      item?.newPosition > 0 ? "green" : "red"
                                    }
                                    style={{ marginRight: "3px" }}
                                  />
                                  {item?.newPosition > 0
                                    ? Math.abs(item?.newPosition).toFixed(2)
                                    : `(${Math.abs(item?.newPosition).toFixed(
                                        2
                                      )})`}
                                </span>
                              )}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>

                    <td
                      style={{ borderLeft: "none" }}
                      class="w-45 text-center position-relative"
                    >
                      <div class="">
                        <div class="widt50fleft">
                          {" "}
                          <div
                            className="bid position-relative curser-pointer disabled-new-div"
                            style={{ cursor: "pointer" }}
                          >
                            {" "}
                            <span className="disabled"></span>
                            <span class="bid-price"></span>
                          </div>{" "}
                          <div
                            className="bid position-relative curser-pointer disabled-new-div"
                            style={{ cursor: "pointer" }}
                          >
                            {" "}
                            <span className="disabled"></span>
                            <span class="bid-price"></span>
                          </div>
                          <div
                            onClick={() => {
                              handelChange(
                                98,
                                "back",
                                item?.RunnerName,
                                item,
                                index
                              );
                            }}
                            className="bid position-relative curser-pointer "
                            style={{ cursor: "pointer" }}
                          >
                            <span class="bid-price">98</span>
                          </div>
                        </div>

                        <div class="widt50fleft">
                          <div
                            className="ask position-relative curser-pointer disabled-new-div"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="disabled"></span>

                            <span class="bid-price"></span>
                          </div>{" "}
                          <div
                            className="ask position-relative curser-pointer disabled-new-div"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="disabled"></span>

                            <span class="bid-price"></span>
                          </div>{" "}
                          <div
                            className="ask position-relative curser-pointer disabled-new-div"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="disabled"></span>

                            <span class="bid-price"></span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  {name == "toss" &&
                    betSlipObject?.teamName ==
                      (item?.RunnerName || item?.runnerName) &&
                    !isEmpty(betSlipObject?.betType) &&
                    betSlipObject?.playType == "toss" && <RenderSlip />}
                </>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* {!isEmpty(localLimit) && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            color: "black",
            fontSize: "12px",
            marginBottom: "4px",
          }}
        >
          {t("Min")} :{" "}
          <span style={{ fontWeight: "600", margin: "0 3px" }}>
            {format(localLimit?.minAmount)}
          </span>{" "}
          | {t("Max")} :{" "}
          <span style={{ fontWeight: "600", margin: "0 3px" }}>
            {format(localLimit?.maxAmount)}
          </span>
        </div>
      )} */}
    </div>
  );
};

export default Toss;
